import {NotificationService} from "../../services/NotificationService";
import {BaseEntity} from "../../entities/BaseEntity";
import { StateService } from "@uirouter/angularjs";
import { ServerImportModel } from "../../models/serverimport/ServerImportModel";

export class ServerImportMapFieldsCtrl<T extends BaseEntity> {
    public static $inject = ['$scope', '$state', 'ImportModel', 'NotificationService'];
    working: boolean = false;
    constructor(public $scope: any, public stateService: StateService, public model: ServerImportModel<T>, public notifyService: NotificationService) {
        this.$scope.vm = this;
    }
    previous(): void {
        this.stateService.go(this.model.getRoute(""));
    }
    next(): void {
        var ok: boolean = this.model.validateImportColumns();
        if (!ok) {
            this.notifyService.notifyError("Please select a value for all required fields.");
        }
        else {
            this.working = true;
            this.model.startImport(true).then((ok) => {
                this.working = false;
                if (ok) {
                    if (this.model.errors.length == 0) {
                        this.stateService.go(this.model.getRoute("confirm"));
                    }
                    else {
                        this.stateService.go(this.model.getRoute("fixerrors"));
                    }
                }                
            }).catch((exc) => {
                this.notifyService.notifyError("Got error in testing import:" + exc);
                this.working = false;
            })
        }
    }//next   
}